import  { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import Layout from "../components/layout/Calayout";

// Sample performance data
const performanceData = {
  clientGrowth: [
    { month: "Jan", clients: 50 },
    { month: "Feb", clients: 65 },
    { month: "Mar", clients: 80 },
    { month: "Apr", clients: 95 },
    { month: "May", clients: 110 },
    { month: "Jun", clients: 130 },
  ],
  revenueData: [
    { month: "Jan", revenue: 50000 },
    { month: "Feb", revenue: 65000 },
    { month: "Mar", revenue: 80000 },
    { month: "Apr", revenue: 95000 },
    { month: "May", revenue: 110000 },
    { month: "Jun", revenue: 130000 },
  ],
  taskCompletionData: [
    { type: "Tax Filing", completed: 85, pending: 15 },
    { type: "Audit", completed: 70, pending: 30 },
    { type: "Consulting", completed: 90, pending: 10 },
  ],
};

const PerformanceDashboard = () => {
  const [selectedMetric, setSelectedMetric] = useState("clientGrowth");

  const renderChart = () => {
    switch (selectedMetric) {
      case "clientGrowth":
        return (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={performanceData.clientGrowth}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="clients"
                stroke="#8884d8"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        );
      case "revenue":
        return (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={performanceData.revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip formatter={(value) => [`₹${value}`, "Revenue"]} />
              <Bar dataKey="revenue" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        );
      case "taskCompletion":
        return (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={performanceData.taskCompletionData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="type" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="completed" stackId="a" fill="#8884d8" />
              <Bar dataKey="pending" stackId="a" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        );
      default:
        return null;
    }
  };

  return (
    <Layout>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Performance Dashboard
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6">Performance Metrics</Typography>
                  <FormControl variant="outlined" sx={{ minWidth: 200 }}>
                    <InputLabel>Select Metric</InputLabel>
                    <Select
                      value={selectedMetric}
                      onChange={(e) => setSelectedMetric(e.target.value)}
                      label="Select Metric"
                    >
                      <MenuItem value="clientGrowth">Client Growth</MenuItem>
                      <MenuItem value="revenue">Revenue</MenuItem>
                      <MenuItem value="taskCompletion">
                        Task Completion
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {renderChart()}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">Key Performance Indicators</Typography>
                <Typography>Total Clients: 130</Typography>
                <Typography>Total Revenue: ₹130,000</Typography>
                <Typography>Task Completion Rate: 85%</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Card>
              <CardContent>
                <Typography variant="h6">Performance Summary</Typography>
                <Typography>
                  The performance dashboard shows consistent growth in client
                  acquisition, revenue, and task completion rates over the past
                  six months.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default PerformanceDashboard;
